import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    alignItems: 'flex-start',
    marginTop: 0,
    marginBottom: 0,
    fontDefaultSemiBold: 20,
    lineHeight: '1.2em',
    color: colors.space,

    maxWidthMobile: {
      fontDefaultSemiBold: 18,
    },

    maxWidthTabletSm: {
      minWidthTablet: {
        fontDefaultSemiBold: 18,
      },
    },

    maxWidthTablet: {
      minWidthTabletLg: {
        fontDefaultSemiBold: 20,
      },
    },

    minWidthDesktop: {
      fontDefaultSemiBold: 20,
    },
  },
});

export default styles;
